import React from 'react'
import {UIGameActionButton} from '../../../common/UIGameActionButton/index.ts'
import IconCheck from '@static/images/icon_check.svg'
import {type TradeResponse, TradeActions, type TradeValidator} from '@colonist/game-mechanic-validators'
import {TradeResponseStatus} from '@colonist/game-states'
import {type TranslationKeys} from '@colonist/i18n'
import styles from '../UIGameTradeOffers.module.scss'
import clsx from 'clsx'
import {T} from '@colonist/ui'
import {useUIGameSocketContext} from '../../../contexts/UIGameSocketContext.tsx'
import {useGameStore} from '../../../store/GameStoreContext.ts'

export interface UIGameTradeOfferAcceptTradeButtonProps {
    className?: string | undefined
    tradeValidator: TradeValidator
    setIsOtherButtonsClicked: (isOtherButtonsClicked: boolean) => void
    disableTooltips?: boolean | undefined
}

export const UIGameTradeOfferAcceptTradeButton = ({
    className,
    tradeValidator,
    setIsOtherButtonsClicked,
    disableTooltips,
}: UIGameTradeOfferAcceptTradeButtonProps) => {
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)
    const myColor = useGameStore((state) => state.myColor)
    const {sendForceOpenGuideBubble} = useUIGameSocketContext()
    const sendUpdateTradeResponse = useGameStore((state) => state.gameTradeOffers.sendUpdateTradeResponse)
    const acceptAction = tradeValidator.getAcceptTradeActionStatus(myColor)
    const myResponseStatus = tradeValidator.getPlayerResponseState(myColor)
    const highlighted = myResponseStatus?.responseStatus == TradeResponseStatus.Accepted
    const isHidden = !acceptAction.displayActionButton
    const tooltipText: TranslationKeys = 'strings:game.tooltips.acceptTrade'
    const helperText = acceptAction.errorMessageIfCantTakeAction
    const isEnabled = acceptAction.canTakeAction && !isMyColorSpectator
    const isEmbargoed = myResponseStatus?.responseStatus == TradeResponseStatus.Embargoed

    const handleClick = () => {
        const isRejectForcedBeginnerMode = tradeValidator.state.forcedResponse == TradeResponseStatus.Rejected
        if(isRejectForcedBeginnerMode) {
            sendForceOpenGuideBubble()
            return
        }
        const acceptTrade: TradeResponse = {
            id: tradeValidator.state.id,
            response: TradeActions.Accept,
        }
        sendUpdateTradeResponse(acceptTrade)
        setIsOtherButtonsClicked(true)
    }

    if(isHidden) return null
    return (
        <UIGameActionButton
            tooltipContent={<T id={tooltipText}/>}
            centerTextTooltip
            className={clsx(styles.tradeButton, className)}
            iconPath={IconCheck}
            onClick={handleClick}
            buttonType="trade"
            tooltipPosition='bottom'
            helperText={helperText}
            disabled={!isEnabled}
            isEmbargoed={isEmbargoed}
            highlight={highlighted}
            tooltipDisabled={disableTooltips}
        />
    )
}
